// src/components/store/sections/hero-banner/HeroV92CathedralarchCrimsonRose.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV92CathedralarchCrimsonRose(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={92}
      archKey="cathedral_arch"
      archLabel="Cathedral Arch Stage"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      {...props}
    />
  );
}
